import { useMemo } from "react";

import Box from "ds/components/Box";
import Card from "ds/components/Card";
import Typography from "ds/components/Typography";
import ExportTracesButton from "components/Run/elements/ExportTraces/Button";
import { RunState, RunWorkerMetrics } from "types/generated";

import { PHASE_EXECUTION_TIME_GRID_TEMPLATE } from "./constants";
import PhaseExecutionTimeRow from "./Row";
import styles from "./styles.module.css";
import { getPhaseExecutionTimeBars } from "./utils";

type PhaseExecutionTimeProps = {
  workerMetrics: RunWorkerMetrics;
  onPhaseSelect?: (phase: RunState) => void;
};

const PhaseExecutionTime = ({ workerMetrics, onPhaseSelect }: PhaseExecutionTimeProps) => {
  const bars = useMemo(
    () => getPhaseExecutionTimeBars(workerMetrics.states),
    [workerMetrics.states]
  );

  if (bars.length === 0) {
    return null;
  }

  return (
    <Card
      title="Phase execution time"
      titleTag="h3"
      headerSuffix={<ExportTracesButton size="small" source="phaseExecutionTime" />}
      contentGap="0"
      contentClassName={styles.content}
      fullbleed
    >
      <Box direction="column" className={styles.table}>
        <Box
          grid
          gridTemplate={PHASE_EXECUTION_TIME_GRID_TEMPLATE}
          gap="x-large"
          padding="0 x-large"
          className={styles.headerStrip}
        >
          <Box
            align="center"
            justify="between"
            padding="0 x-large 0 0"
            className={styles.phaseHeaderCell}
          >
            <Typography tag="span" variant="p-body4" color="secondary">
              Phase
            </Typography>
            <Typography tag="span" variant="p-body4" color="secondary">
              vs P95
            </Typography>
          </Box>
        </Box>

        {bars.map((bar) => (
          <PhaseExecutionTimeRow key={bar.state.runState} {...bar} onSelect={onPhaseSelect} />
        ))}
      </Box>
    </Card>
  );
};

export default PhaseExecutionTime;
